"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentsApi = void 0;
var runtime = require("../runtime");
var index_1 = require("../models/index");
/**
 *
 */
var ExperimentsApi = /** @class */ (function (_super) {
    __extends(ExperimentsApi, _super);
    function ExperimentsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a mapping of ad set to experiment.
     * Create Ad Set To Experiment Mapping
     */
    ExperimentsApi.prototype.createAdSetToExperimentMappingRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling createAdSetToExperimentMapping.');
                        }
                        if (requestParameters.adSetId === null || requestParameters.adSetId === undefined) {
                            throw new runtime.RequiredError('adSetId', 'Required parameter requestParameters.adSetId was null or undefined when calling createAdSetToExperimentMapping.');
                        }
                        if (requestParameters.createAdSetToExperimentMappingRequest === null || requestParameters.createAdSetToExperimentMappingRequest === undefined) {
                            throw new runtime.RequiredError('createAdSetToExperimentMappingRequest', 'Required parameter requestParameters.createAdSetToExperimentMappingRequest was null or undefined when calling createAdSetToExperimentMapping.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/experiments/ad_set_mappings/{ad_set_id}".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("ad_set_id", "}"), encodeURIComponent(String(requestParameters.adSetId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CreateAdSetToExperimentMappingRequestToJSON)(requestParameters.createAdSetToExperimentMappingRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Create a mapping of ad set to experiment.
     * Create Ad Set To Experiment Mapping
     */
    ExperimentsApi.prototype.createAdSetToExperimentMapping = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createAdSetToExperimentMappingRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates experiment belonging to provided ad account.
     * Create Experiment
     */
    ExperimentsApi.prototype.createExperimentRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling createExperiment.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/experiments".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CreateExperimentRequestToJSON)(requestParameters.createExperimentRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CreateExperimentResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates experiment belonging to provided ad account.
     * Create Experiment
     */
    ExperimentsApi.prototype.createExperiment = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createExperimentRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create audience mapping for an experiment.
     * Create Experiment Audiences
     */
    ExperimentsApi.prototype.createExperimentToAudienceMappingRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling createExperimentToAudienceMapping.');
                        }
                        if (requestParameters.experimentId === null || requestParameters.experimentId === undefined) {
                            throw new runtime.RequiredError('experimentId', 'Required parameter requestParameters.experimentId was null or undefined when calling createExperimentToAudienceMapping.');
                        }
                        if (requestParameters.createExperimentToAudienceMappingRequest === null || requestParameters.createExperimentToAudienceMappingRequest === undefined) {
                            throw new runtime.RequiredError('createExperimentToAudienceMappingRequest', 'Required parameter requestParameters.createExperimentToAudienceMappingRequest was null or undefined when calling createExperimentToAudienceMapping.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/experiments/{experiment_id}/audience_mappings".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("experiment_id", "}"), encodeURIComponent(String(requestParameters.experimentId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CreateExperimentToAudienceMappingRequestToJSON)(requestParameters.createExperimentToAudienceMappingRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Create audience mapping for an experiment.
     * Create Experiment Audiences
     */
    ExperimentsApi.prototype.createExperimentToAudienceMapping = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createExperimentToAudienceMappingRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Create a mapping of survey asset language translations.
     * Create Survey Asset Translation Mapping
     */
    ExperimentsApi.prototype.createSurveyAssetTranslationMappingRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createSurveyAssetTranslationMappingRequest === null || requestParameters.createSurveyAssetTranslationMappingRequest === undefined) {
                            throw new runtime.RequiredError('createSurveyAssetTranslationMappingRequest', 'Required parameter requestParameters.createSurveyAssetTranslationMappingRequest was null or undefined when calling createSurveyAssetTranslationMapping.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/experiments/survey_asset_translation_mappings",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CreateSurveyAssetTranslationMappingRequestToJSON)(requestParameters.createSurveyAssetTranslationMappingRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Create a mapping of survey asset language translations.
     * Create Survey Asset Translation Mapping
     */
    ExperimentsApi.prototype.createSurveyAssetTranslationMapping = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createSurveyAssetTranslationMappingRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Create a survey market
     * Create Survey Market
     */
    ExperimentsApi.prototype.createSurveyMarketRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling createSurveyMarket.');
                        }
                        if (requestParameters.experimentId === null || requestParameters.experimentId === undefined) {
                            throw new runtime.RequiredError('experimentId', 'Required parameter requestParameters.experimentId was null or undefined when calling createSurveyMarket.');
                        }
                        if (requestParameters.createSurveyMarketRequest === null || requestParameters.createSurveyMarketRequest === undefined) {
                            throw new runtime.RequiredError('createSurveyMarketRequest', 'Required parameter requestParameters.createSurveyMarketRequest was null or undefined when calling createSurveyMarket.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/experiments/{experiment_id}/survey_market".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("experiment_id", "}"), encodeURIComponent(String(requestParameters.experimentId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CreateSurveyMarketRequestToJSON)(requestParameters.createSurveyMarketRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Create a survey market
     * Create Survey Market
     */
    ExperimentsApi.prototype.createSurveyMarket = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createSurveyMarketRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Create a survey campaign mapping for a survey experiment.
     * Create Survey to Survey Campaign Mapping
     */
    ExperimentsApi.prototype.createSurveyToSurveyCampaignMappingRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling createSurveyToSurveyCampaignMapping.');
                        }
                        if (requestParameters.experimentId === null || requestParameters.experimentId === undefined) {
                            throw new runtime.RequiredError('experimentId', 'Required parameter requestParameters.experimentId was null or undefined when calling createSurveyToSurveyCampaignMapping.');
                        }
                        if (requestParameters.createSurveyToSurveyCampaignMappingRequest === null || requestParameters.createSurveyToSurveyCampaignMappingRequest === undefined) {
                            throw new runtime.RequiredError('createSurveyToSurveyCampaignMappingRequest', 'Required parameter requestParameters.createSurveyToSurveyCampaignMappingRequest was null or undefined when calling createSurveyToSurveyCampaignMapping.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/experiments/{experiment_id}/survey_campaign_mapping".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("experiment_id", "}"), encodeURIComponent(String(requestParameters.experimentId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CreateSurveyToSurveyCampaignMappingRequestToJSON)(requestParameters.createSurveyToSurveyCampaignMappingRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Create a survey campaign mapping for a survey experiment.
     * Create Survey to Survey Campaign Mapping
     */
    ExperimentsApi.prototype.createSurveyToSurveyCampaignMapping = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createSurveyToSurveyCampaignMappingRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get the mapping of ad set to experiment
     * Get Ad Set To Experiment Mapping
     */
    ExperimentsApi.prototype.getAdSetToExperimentMappingRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getAdSetToExperimentMapping.');
                        }
                        if (requestParameters.adSetId === null || requestParameters.adSetId === undefined) {
                            throw new runtime.RequiredError('adSetId', 'Required parameter requestParameters.adSetId was null or undefined when calling getAdSetToExperimentMapping.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/experiments/ad_set_mappings/{ad_set_id}".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("ad_set_id", "}"), encodeURIComponent(String(requestParameters.adSetId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AdSetToExperimentMappingResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get the mapping of ad set to experiment
     * Get Ad Set To Experiment Mapping
     */
    ExperimentsApi.prototype.getAdSetToExperimentMapping = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAdSetToExperimentMappingRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns validated eligibility data for given set of campaign IDs, for SBL V2.
     * Get validated eligibility data for given campaign IDs
     */
    ExperimentsApi.prototype.getEligibilityRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getEligibility.');
                        }
                        queryParameters = {};
                        if (requestParameters.campaignIds) {
                            queryParameters['campaign_ids'] = requestParameters.campaignIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.test !== undefined) {
                            queryParameters['test'] = requestParameters.test;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/experiments/eligibility".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetEligibilityResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns validated eligibility data for given set of campaign IDs, for SBL V2.
     * Get validated eligibility data for given campaign IDs
     */
    ExperimentsApi.prototype.getEligibility = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getEligibilityRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns an eligibility campaign based on a given campaign ID, for SBL V1.
     * Get eligibility campaign by campaign ID
     */
    ExperimentsApi.prototype.getEligibilityCampaignRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getEligibilityCampaign.');
                        }
                        if (requestParameters.campaignId === null || requestParameters.campaignId === undefined) {
                            throw new runtime.RequiredError('campaignId', 'Required parameter requestParameters.campaignId was null or undefined when calling getEligibilityCampaign.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/experiments/eligibility_campaigns/{campaign_id}".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("campaign_id", "}"), encodeURIComponent(String(requestParameters.campaignId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetEligibilityCampaignResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns an eligibility campaign based on a given campaign ID, for SBL V1.
     * Get eligibility campaign by campaign ID
     */
    ExperimentsApi.prototype.getEligibilityCampaign = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getEligibilityCampaignRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns estimated impression and bdl_check for list of ad sets.
     * Get Estimated Impressions
     */
    ExperimentsApi.prototype.getEstimatedImpressionsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getEstimatedImpressions.');
                        }
                        if (requestParameters.experimentId === null || requestParameters.experimentId === undefined) {
                            throw new runtime.RequiredError('experimentId', 'Required parameter requestParameters.experimentId was null or undefined when calling getEstimatedImpressions.');
                        }
                        if (requestParameters.getImpressionAndBDLCheckRequest === null || requestParameters.getImpressionAndBDLCheckRequest === undefined) {
                            throw new runtime.RequiredError('getImpressionAndBDLCheckRequest', 'Required parameter requestParameters.getImpressionAndBDLCheckRequest was null or undefined when calling getEstimatedImpressions.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/experiments/{experiment_id}/impressions".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("experiment_id", "}"), encodeURIComponent(String(requestParameters.experimentId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.GetImpressionAndBDLCheckRequestToJSON)(requestParameters.getImpressionAndBDLCheckRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetImpressionAndBDLCheckResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns estimated impression and bdl_check for list of ad sets.
     * Get Estimated Impressions
     */
    ExperimentsApi.prototype.getEstimatedImpressions = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getEstimatedImpressionsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns experiment based on a given experiment ID.
     * Get Experiment by ID
     */
    ExperimentsApi.prototype.getExperimentRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getExperiment.');
                        }
                        if (requestParameters.experimentId === null || requestParameters.experimentId === undefined) {
                            throw new runtime.RequiredError('experimentId', 'Required parameter requestParameters.experimentId was null or undefined when calling getExperiment.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/experiments/{experiment_id}".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("experiment_id", "}"), encodeURIComponent(String(requestParameters.experimentId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetExperimentResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns experiment based on a given experiment ID.
     * Get Experiment by ID
     */
    ExperimentsApi.prototype.getExperiment = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getExperimentRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the status of an experiment\'s ad entity creation step(s). Used by sbl-sas-async-service.
     * Get Experiment Ad Entity Creation Status
     */
    ExperimentsApi.prototype.getExperimentAdEntityCreationStatusRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getExperimentAdEntityCreationStatus.');
                        }
                        if (requestParameters.experimentId === null || requestParameters.experimentId === undefined) {
                            throw new runtime.RequiredError('experimentId', 'Required parameter requestParameters.experimentId was null or undefined when calling getExperimentAdEntityCreationStatus.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/experiments/{experiment_id}/ad_entity_status".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("experiment_id", "}"), encodeURIComponent(String(requestParameters.experimentId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ExperimentAdEntityStatusResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the status of an experiment\'s ad entity creation step(s). Used by sbl-sas-async-service.
     * Get Experiment Ad Entity Creation Status
     */
    ExperimentsApi.prototype.getExperimentAdEntityCreationStatus = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getExperimentAdEntityCreationStatusRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the audiences associated with an experiment.
     * Get Experiment Audiences
     */
    ExperimentsApi.prototype.getExperimentToAudienceMappingsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getExperimentToAudienceMappings.');
                        }
                        if (requestParameters.experimentId === null || requestParameters.experimentId === undefined) {
                            throw new runtime.RequiredError('experimentId', 'Required parameter requestParameters.experimentId was null or undefined when calling getExperimentToAudienceMappings.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/experiments/{experiment_id}/audience_mappings".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("experiment_id", "}"), encodeURIComponent(String(requestParameters.experimentId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ExperimentAudienceMappingsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the audiences associated with an experiment.
     * Get Experiment Audiences
     */
    ExperimentsApi.prototype.getExperimentToAudienceMappings = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getExperimentToAudienceMappingsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns paginated list of experiments.
     * Get Experiments
     */
    ExperimentsApi.prototype.getExperimentsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getExperiments.');
                        }
                        if (requestParameters.type === null || requestParameters.type === undefined) {
                            throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling getExperiments.');
                        }
                        queryParameters = {};
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        if (requestParameters.sortDirection !== undefined) {
                            queryParameters['sort_direction'] = requestParameters.sortDirection;
                        }
                        if (requestParameters.sortField !== undefined) {
                            queryParameters['sort_field'] = requestParameters.sortField;
                        }
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        if (requestParameters.status !== undefined) {
                            queryParameters['status'] = requestParameters.status;
                        }
                        if (requestParameters.underivedStatus !== undefined) {
                            queryParameters['underivedStatus'] = requestParameters.underivedStatus;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/experiments".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetExperimentsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns paginated list of experiments.
     * Get Experiments
     */
    ExperimentsApi.prototype.getExperiments = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getExperimentsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns list of all experiments (across ad accounts).
     * Get Experiments Internal
     */
    ExperimentsApi.prototype.getExperimentsInternalRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.type === null || requestParameters.type === undefined) {
                            throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling getExperimentsInternal.');
                        }
                        queryParameters = {};
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        if (requestParameters.status !== undefined) {
                            queryParameters['status'] = requestParameters.status;
                        }
                        if (requestParameters.underivedStatus !== undefined) {
                            queryParameters['underivedStatus'] = requestParameters.underivedStatus;
                        }
                        if (requestParameters.lookahead !== undefined) {
                            queryParameters['lookahead'] = requestParameters.lookahead;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/experiments",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetExperimentsInternalResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns list of all experiments (across ad accounts).
     * Get Experiments Internal
     */
    ExperimentsApi.prototype.getExperimentsInternal = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getExperimentsInternalRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get the mapping of survey asset language translations.
     * Get Survey Asset Translation Mapping
     */
    ExperimentsApi.prototype.getSurveyAssetTranslationMappingRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.languageCode === null || requestParameters.languageCode === undefined) {
                            throw new runtime.RequiredError('languageCode', 'Required parameter requestParameters.languageCode was null or undefined when calling getSurveyAssetTranslationMapping.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/experiments/survey_asset_translation_mappings/{language_code}".replace("{".concat("language_code", "}"), encodeURIComponent(String(requestParameters.languageCode))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.SurveyAssetTranslationMappingResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get the mapping of survey asset language translations.
     * Get Survey Asset Translation Mapping
     */
    ExperimentsApi.prototype.getSurveyAssetTranslationMapping = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSurveyAssetTranslationMappingRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the survey market id associated with a survey experiment id and market.
     * Get Survey Market
     */
    ExperimentsApi.prototype.getSurveyMarketRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getSurveyMarket.');
                        }
                        if (requestParameters.experimentId === null || requestParameters.experimentId === undefined) {
                            throw new runtime.RequiredError('experimentId', 'Required parameter requestParameters.experimentId was null or undefined when calling getSurveyMarket.');
                        }
                        if (requestParameters.getSurveyMarketRequest === null || requestParameters.getSurveyMarketRequest === undefined) {
                            throw new runtime.RequiredError('getSurveyMarketRequest', 'Required parameter requestParameters.getSurveyMarketRequest was null or undefined when calling getSurveyMarket.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/experiments/{experiment_id}/survey_market".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("experiment_id", "}"), encodeURIComponent(String(requestParameters.experimentId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.GetSurveyMarketRequestToJSON)(requestParameters.getSurveyMarketRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetSurveyMarketResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the survey market id associated with a survey experiment id and market.
     * Get Survey Market
     */
    ExperimentsApi.prototype.getSurveyMarket = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSurveyMarketRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Return the survey markets associated with a survey experiment id.
     * Get Survey Markets
     */
    ExperimentsApi.prototype.getSurveyMarketsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getSurveyMarkets.');
                        }
                        if (requestParameters.experimentId === null || requestParameters.experimentId === undefined) {
                            throw new runtime.RequiredError('experimentId', 'Required parameter requestParameters.experimentId was null or undefined when calling getSurveyMarkets.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/experiments/{experiment_id}/survey_markets".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("experiment_id", "}"), encodeURIComponent(String(requestParameters.experimentId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetSurveyMarketsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Return the survey markets associated with a survey experiment id.
     * Get Survey Markets
     */
    ExperimentsApi.prototype.getSurveyMarkets = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSurveyMarketsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the status of an experiment\'s survey question mapping step(s). Used by sbl-sas-async-service.
     * Get Survey Question Status
     */
    ExperimentsApi.prototype.getSurveyQuestionStatusesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getSurveyQuestionStatuses.');
                        }
                        if (requestParameters.experimentId === null || requestParameters.experimentId === undefined) {
                            throw new runtime.RequiredError('experimentId', 'Required parameter requestParameters.experimentId was null or undefined when calling getSurveyQuestionStatuses.');
                        }
                        if (requestParameters.surveyQuestionId === null || requestParameters.surveyQuestionId === undefined) {
                            throw new runtime.RequiredError('surveyQuestionId', 'Required parameter requestParameters.surveyQuestionId was null or undefined when calling getSurveyQuestionStatuses.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/experiments/{experiment_id}/questions/{survey_question_id}/statuses".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("experiment_id", "}"), encodeURIComponent(String(requestParameters.experimentId))).replace("{".concat("survey_question_id", "}"), encodeURIComponent(String(requestParameters.surveyQuestionId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.SurveyQuestionStatusesResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the status of an experiment\'s survey question mapping step(s). Used by sbl-sas-async-service.
     * Get Survey Question Status
     */
    ExperimentsApi.prototype.getSurveyQuestionStatuses = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSurveyQuestionStatusesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the survey campaign id associated with a survey experiment id.
     * Get Survey Experiment Survey Campaign Mapping
     */
    ExperimentsApi.prototype.getSurveyToSurveyCampaignMappingRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getSurveyToSurveyCampaignMapping.');
                        }
                        if (requestParameters.experimentId === null || requestParameters.experimentId === undefined) {
                            throw new runtime.RequiredError('experimentId', 'Required parameter requestParameters.experimentId was null or undefined when calling getSurveyToSurveyCampaignMapping.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/experiments/{experiment_id}/survey_campaign_mapping".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("experiment_id", "}"), encodeURIComponent(String(requestParameters.experimentId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.SurveyToSurveyCampaignMappingResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the survey campaign id associated with a survey experiment id.
     * Get Survey Experiment Survey Campaign Mapping
     */
    ExperimentsApi.prototype.getSurveyToSurveyCampaignMapping = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSurveyToSurveyCampaignMappingRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Migrate a V1 survey to V2.
     * Migrate V1 survey to V2.
     */
    ExperimentsApi.prototype.migrateV1ToV2Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling migrateV1ToV2.');
                        }
                        if (requestParameters.experimentId === null || requestParameters.experimentId === undefined) {
                            throw new runtime.RequiredError('experimentId', 'Required parameter requestParameters.experimentId was null or undefined when calling migrateV1ToV2.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/experiments/{experiment_id}/migrate".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("experiment_id", "}"), encodeURIComponent(String(requestParameters.experimentId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Migrate a V1 survey to V2.
     * Migrate V1 survey to V2.
     */
    ExperimentsApi.prototype.migrateV1ToV2 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.migrateV1ToV2Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates experiment by experiment ID.
     * Update Experiment by ID
     */
    ExperimentsApi.prototype.updateExperimentRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling updateExperiment.');
                        }
                        if (requestParameters.experimentId === null || requestParameters.experimentId === undefined) {
                            throw new runtime.RequiredError('experimentId', 'Required parameter requestParameters.experimentId was null or undefined when calling updateExperiment.');
                        }
                        if (requestParameters.updateExperimentRequest === null || requestParameters.updateExperimentRequest === undefined) {
                            throw new runtime.RequiredError('updateExperimentRequest', 'Required parameter requestParameters.updateExperimentRequest was null or undefined when calling updateExperiment.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/experiments/{experiment_id}".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("experiment_id", "}"), encodeURIComponent(String(requestParameters.experimentId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.UpdateExperimentRequestToJSON)(requestParameters.updateExperimentRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Updates experiment by experiment ID.
     * Update Experiment by ID
     */
    ExperimentsApi.prototype.updateExperiment = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateExperimentRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates the status of an experiment\'s ad entity creation step(s). Used by sbl-sas-async-service.
     * Update Experiment Ad Entity Creation Status
     */
    ExperimentsApi.prototype.updateExperimentAdEntityCreationStatusRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling updateExperimentAdEntityCreationStatus.');
                        }
                        if (requestParameters.experimentId === null || requestParameters.experimentId === undefined) {
                            throw new runtime.RequiredError('experimentId', 'Required parameter requestParameters.experimentId was null or undefined when calling updateExperimentAdEntityCreationStatus.');
                        }
                        if (requestParameters.updateExperimentAdEntityStatusRequest === null || requestParameters.updateExperimentAdEntityStatusRequest === undefined) {
                            throw new runtime.RequiredError('updateExperimentAdEntityStatusRequest', 'Required parameter requestParameters.updateExperimentAdEntityStatusRequest was null or undefined when calling updateExperimentAdEntityCreationStatus.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/experiments/{experiment_id}/ad_entity_status".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("experiment_id", "}"), encodeURIComponent(String(requestParameters.experimentId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.UpdateExperimentAdEntityStatusRequestToJSON)(requestParameters.updateExperimentAdEntityStatusRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Updates the status of an experiment\'s ad entity creation step(s). Used by sbl-sas-async-service.
     * Update Experiment Ad Entity Creation Status
     */
    ExperimentsApi.prototype.updateExperimentAdEntityCreationStatus = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateExperimentAdEntityCreationStatusRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update the status of an experiment.
     * Update Experiment Status
     */
    ExperimentsApi.prototype.updateExperimentStatusRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling updateExperimentStatus.');
                        }
                        if (requestParameters.experimentId === null || requestParameters.experimentId === undefined) {
                            throw new runtime.RequiredError('experimentId', 'Required parameter requestParameters.experimentId was null or undefined when calling updateExperimentStatus.');
                        }
                        if (requestParameters.updateExperimentStatusRequest === null || requestParameters.updateExperimentStatusRequest === undefined) {
                            throw new runtime.RequiredError('updateExperimentStatusRequest', 'Required parameter requestParameters.updateExperimentStatusRequest was null or undefined when calling updateExperimentStatus.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/experiments/{experiment_id}/status".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("experiment_id", "}"), encodeURIComponent(String(requestParameters.experimentId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.UpdateExperimentStatusRequestToJSON)(requestParameters.updateExperimentStatusRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update the status of an experiment.
     * Update Experiment Status
     */
    ExperimentsApi.prototype.updateExperimentStatus = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateExperimentStatusRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update the status of multiple experiments.
     * Update Experiment Statuses
     */
    ExperimentsApi.prototype.updateExperimentStatusesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling updateExperimentStatuses.');
                        }
                        if (requestParameters.updateExperimentStatusesRequest === null || requestParameters.updateExperimentStatusesRequest === undefined) {
                            throw new runtime.RequiredError('updateExperimentStatusesRequest', 'Required parameter requestParameters.updateExperimentStatusesRequest was null or undefined when calling updateExperimentStatuses.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/experiments/statuses".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.UpdateExperimentStatusesRequestToJSON)(requestParameters.updateExperimentStatusesRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update the status of multiple experiments.
     * Update Experiment Statuses
     */
    ExperimentsApi.prototype.updateExperimentStatuses = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateExperimentStatusesRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update the mapping of survey asset language translations.
     * Update Survey Asset Translation Mapping
     */
    ExperimentsApi.prototype.updateSurveyAssetTranslationMappingRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.languageCode === null || requestParameters.languageCode === undefined) {
                            throw new runtime.RequiredError('languageCode', 'Required parameter requestParameters.languageCode was null or undefined when calling updateSurveyAssetTranslationMapping.');
                        }
                        if (requestParameters.updateSurveyAssetTranslationMappingRequest === null || requestParameters.updateSurveyAssetTranslationMappingRequest === undefined) {
                            throw new runtime.RequiredError('updateSurveyAssetTranslationMappingRequest', 'Required parameter requestParameters.updateSurveyAssetTranslationMappingRequest was null or undefined when calling updateSurveyAssetTranslationMapping.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/experiments/survey_asset_translation_mappings/{language_code}".replace("{".concat("language_code", "}"), encodeURIComponent(String(requestParameters.languageCode))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.UpdateSurveyAssetTranslationMappingRequestToJSON)(requestParameters.updateSurveyAssetTranslationMappingRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update the mapping of survey asset language translations.
     * Update Survey Asset Translation Mapping
     */
    ExperimentsApi.prototype.updateSurveyAssetTranslationMapping = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateSurveyAssetTranslationMappingRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates the market of a survey market.
     * Update Survey Market
     */
    ExperimentsApi.prototype.updateSurveyMarketRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling updateSurveyMarket.');
                        }
                        if (requestParameters.experimentId === null || requestParameters.experimentId === undefined) {
                            throw new runtime.RequiredError('experimentId', 'Required parameter requestParameters.experimentId was null or undefined when calling updateSurveyMarket.');
                        }
                        if (requestParameters.updateSurveyMarketRequest === null || requestParameters.updateSurveyMarketRequest === undefined) {
                            throw new runtime.RequiredError('updateSurveyMarketRequest', 'Required parameter requestParameters.updateSurveyMarketRequest was null or undefined when calling updateSurveyMarket.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/experiments/{experiment_id}/survey_market".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("experiment_id", "}"), encodeURIComponent(String(requestParameters.experimentId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.UpdateSurveyMarketRequestToJSON)(requestParameters.updateSurveyMarketRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Updates the market of a survey market.
     * Update Survey Market
     */
    ExperimentsApi.prototype.updateSurveyMarket = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateSurveyMarketRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update a survey option
     * Update survey option.
     */
    ExperimentsApi.prototype.updateSurveyOptionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling updateSurveyOption.');
                        }
                        if (requestParameters.experimentId === null || requestParameters.experimentId === undefined) {
                            throw new runtime.RequiredError('experimentId', 'Required parameter requestParameters.experimentId was null or undefined when calling updateSurveyOption.');
                        }
                        if (requestParameters.surveyOptionId === null || requestParameters.surveyOptionId === undefined) {
                            throw new runtime.RequiredError('surveyOptionId', 'Required parameter requestParameters.surveyOptionId was null or undefined when calling updateSurveyOption.');
                        }
                        if (requestParameters.updateSurveyOptionRequest === null || requestParameters.updateSurveyOptionRequest === undefined) {
                            throw new runtime.RequiredError('updateSurveyOptionRequest', 'Required parameter requestParameters.updateSurveyOptionRequest was null or undefined when calling updateSurveyOption.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/experiments/{experiment_id}/survey_options/{survey_option_id}".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("experiment_id", "}"), encodeURIComponent(String(requestParameters.experimentId))).replace("{".concat("survey_option_id", "}"), encodeURIComponent(String(requestParameters.surveyOptionId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.UpdateSurveyOptionRequestToJSON)(requestParameters.updateSurveyOptionRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update a survey option
     * Update survey option.
     */
    ExperimentsApi.prototype.updateSurveyOption = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateSurveyOptionRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update a survey question
     * Update survey question.
     */
    ExperimentsApi.prototype.updateSurveyQuestionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling updateSurveyQuestion.');
                        }
                        if (requestParameters.experimentId === null || requestParameters.experimentId === undefined) {
                            throw new runtime.RequiredError('experimentId', 'Required parameter requestParameters.experimentId was null or undefined when calling updateSurveyQuestion.');
                        }
                        if (requestParameters.surveyQuestionId === null || requestParameters.surveyQuestionId === undefined) {
                            throw new runtime.RequiredError('surveyQuestionId', 'Required parameter requestParameters.surveyQuestionId was null or undefined when calling updateSurveyQuestion.');
                        }
                        if (requestParameters.updateSurveyQuestionRequest === null || requestParameters.updateSurveyQuestionRequest === undefined) {
                            throw new runtime.RequiredError('updateSurveyQuestionRequest', 'Required parameter requestParameters.updateSurveyQuestionRequest was null or undefined when calling updateSurveyQuestion.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/experiments/{experiment_id}/questions/{survey_question_id}".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("experiment_id", "}"), encodeURIComponent(String(requestParameters.experimentId))).replace("{".concat("survey_question_id", "}"), encodeURIComponent(String(requestParameters.surveyQuestionId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.UpdateSurveyQuestionRequestToJSON)(requestParameters.updateSurveyQuestionRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update a survey question
     * Update survey question.
     */
    ExperimentsApi.prototype.updateSurveyQuestion = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateSurveyQuestionRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates the status of an experiment\'s survey question mapping step(s). Used by sbl-sas-async-service.
     * Update Survey Question Status
     */
    ExperimentsApi.prototype.updateSurveyQuestionStatusesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling updateSurveyQuestionStatuses.');
                        }
                        if (requestParameters.experimentId === null || requestParameters.experimentId === undefined) {
                            throw new runtime.RequiredError('experimentId', 'Required parameter requestParameters.experimentId was null or undefined when calling updateSurveyQuestionStatuses.');
                        }
                        if (requestParameters.surveyQuestionId === null || requestParameters.surveyQuestionId === undefined) {
                            throw new runtime.RequiredError('surveyQuestionId', 'Required parameter requestParameters.surveyQuestionId was null or undefined when calling updateSurveyQuestionStatuses.');
                        }
                        if (requestParameters.updateSurveyQuestionStatusesRequest === null || requestParameters.updateSurveyQuestionStatusesRequest === undefined) {
                            throw new runtime.RequiredError('updateSurveyQuestionStatusesRequest', 'Required parameter requestParameters.updateSurveyQuestionStatusesRequest was null or undefined when calling updateSurveyQuestionStatuses.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/experiments/{experiment_id}/questions/{survey_question_id}/statuses".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("experiment_id", "}"), encodeURIComponent(String(requestParameters.experimentId))).replace("{".concat("survey_question_id", "}"), encodeURIComponent(String(requestParameters.surveyQuestionId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.UpdateSurveyQuestionStatusesRequestToJSON)(requestParameters.updateSurveyQuestionStatusesRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Updates the status of an experiment\'s survey question mapping step(s). Used by sbl-sas-async-service.
     * Update Survey Question Status
     */
    ExperimentsApi.prototype.updateSurveyQuestionStatuses = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateSurveyQuestionStatusesRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return ExperimentsApi;
}(runtime.BaseAPI));
exports.ExperimentsApi = ExperimentsApi;
